export default "__VITE_ASSET__db7ee187__"